@if (textarea.title) {
  <div mat-dialog-title>{{textarea.title}}</div>
}
@if (textarea.message) {
  <div mat-dialog-content [innerHTML]="textarea.message"></div>
}
<mat-form-field>
  <mat-label>{{textarea.label}}</mat-label>
  <textarea matInput
    cdkTextareaAutosize
    cdkAutosizeMinRows="3"
    cdkAutosizeMaxRows="10"
    [(ngModel)]="inputValue"
    type="textarea"
    [placeholder]="textarea.placeholder"
    (keydown.enter)="$event.stopPropagation()">
  </textarea>
</mat-form-field>
<div mat-dialog-actions
  align="end">
  <button
    mat-button
    color="primary"
    mat-dialog-close>
    {{textarea.cancelLabel}}
  </button>
  <button
    mat-raised-button
    color="primary"
    (click)="onAddInput()"
    [disabled]="isEmpty()">
    {{textarea.confirmLabel}}
  </button>
</div>
